import { render } from "./About.vue?vue&type=template&id=e9edad6c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=e9edad6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9edad6c"

export default script